import { useCallback } from 'react';
import { LocalStorageKeys } from '~/apps/smartsend/lib/consts/LocalStorageKeys';
import useLocalStorage from '~/hooks/use-local-storage';

type SmartSendOnboardingProgress = 'started' | 'completed';

const useSmartSendOnboardingProgress = () => {
  const { setValue, storedValue } = useLocalStorage(
    LocalStorageKeys.SmartSendOnboardingProgress,
    '' as SmartSendOnboardingProgress
  );

  const setSmartSendOnboardingProgress = useCallback((val: SmartSendOnboardingProgress) => setValue(val), [setValue]);

  return {
    smartSendOnboardingProgress: storedValue as SmartSendOnboardingProgress,
    setSmartSendOnboardingProgress
  } as const;
};

export default useSmartSendOnboardingProgress;
